// extracted by mini-css-extract-plugin
export default {"root":"FieldCurrencyInput_root__JuXIG","inputSuccess":"FieldCurrencyInput_inputSuccess__4PVLQ","inputError":"FieldCurrencyInput_inputError__hd6KT"};